import React, { useState, useEffect } from 'react';
import { Download, X, Smartphone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import usePWAInstall from '../hooks/usePWAInstall';
import '../styles/PWAInstallPrompt.css';

const PWAInstallPrompt = () => {
  const { isInstallable, promptInstall } = usePWAInstall();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only show if browser says it's installable AND user hasn't dismissed it recently
    if (isInstallable) {
      const dismissed = localStorage.getItem('pwaInstallDismissed');
      if (!dismissed) {
        setIsVisible(true);
      }
    }
  }, [isInstallable]);

  const handleDismiss = () => {
    setIsVisible(false);
    // Don't show again for this session or a few days
    localStorage.setItem('pwaInstallDismissed', 'true');
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <div className="pwa-prompt-container">
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 40 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ type: "spring", damping: 25, stiffness: 200 }}
            className="pwa-prompt-card"
          >
            <div className="pwa-icon-box">
              <Smartphone size={28} />
            </div>

            <div className="pwa-content">
              <h3 className="pwa-title">Naturextrakte OBFS App</h3>
              <p className="pwa-description">
                Experience the full power of OBFS with offline access and real-time field alerts.
              </p>
              
              <div className="pwa-buttons">
                <button
                  onClick={promptInstall}
                  className="pwa-install-btn"
                >
                  <Download size={14} className="inline-block mr-2 -mt-0.5" /> 
                  Install Now
                </button>
              </div>
            </div>

            <button 
              onClick={handleDismiss}
              className="pwa-close-btn"
              aria-label="Dismiss install prompt"
            >
              <X size={18} />
            </button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default PWAInstallPrompt;
